import React, { useState, useEffect } from "react";
import {
  Typography,
  Grid,
  Badge,
  Hidden,
  Card,
  CardContent,
  Link,
} from "@material-ui/core";
import { Tooltip } from "@material-ui/core";
import moment from "moment";
import { useSelector } from "react-redux";
import { store } from "../../../../helpers/store";
import { adminService } from "../../../../services/admin.service";
import DatesDropdown from "./_dropdown";
import { makeStyles } from "@material-ui/core/styles";
import {
  white,
  black,
  grey200
} from "material-ui/styles/colors";
import { KeyboardDatePicker } from "@material-ui/pickers";
import { MuiPickersUtilsProvider } from "@material-ui/pickers";
import DateFnsUtils from "@date-io/date-fns";
import { createMuiTheme } from "@material-ui/core";
import { ThemeProvider } from "@material-ui/styles";
import { highestUsage } from "../model/e_highest-usage-days-service";
import { routePaths } from "../../../config/route-paths";
import { Skeleton } from "@material-ui/lab";
// import { notoSansBold,notoSansRegular,notoSansLight,notoSansSemiBold } from "../../../app/app";
import { appStyles } from "../../../app/app-style";
import { useTranslation } from "react-i18next";
import { labels } from "../../../../reducers/labels.reducer";
const useStyles = makeStyles((theme) => ({
  secondaryColorText: {
    color: theme.palette.ePastelColor2?.base + " !important",
  },
  chooseViewText: {
    margin: '10px 0 0 2px ',
    color: theme.palette.eDark?.base + " !important",
  },
  primaryColorText: {
    color: theme.palette.ePrimary?.base + " !important",
  },
  commonWeekdayName: {
    color: theme.palette.ePrimary?.base + " !important",
    fontWeight: 'bold',
  },
  currentMonthText: {
    margin: "auto 8px",
    color: theme.palette.eTertiary?.base + " !important",
    fontWeight: "bold",
  },
  tipsMsgText: {
    color: theme.palette.ePrimary?.base,
    marginTop: "16px",
  },
  title: {
    marginTop: "6px",
    marginLeft: "12px",
    color: theme.palette.ePrimary?.base + " !important",
  },
  cardPadding: {
    padding: "8px !important",
  },
  gridPadding: {
    padding: "0 .2rem",
  },
  messageText: {
    color: theme.palette.eDark?.base + " !important",
    marginTop: "20px",
    fontWeight: "bold",
    paddingRight: "6px"
  },
  totalUsageGrid: {
    marginTop: "16px"
  },
  totalUsageLabel: {
    color: theme.palette.ePrimary?.base,
    fontWeight: "bold",
  },
  totalUsageValueText: {
    fontSize: "20px",
    color: theme.palette.eTertiary?.base,
    fontWeight: "bold",
  },
  arrow: {
    "&:before": {
      border: "2px solid " + theme.palette.quinary.main,
    },
    color: theme.palette.whiteColor.main,
  },
  tooltip: {
    padding: "0.5em",
    backgroundColor: theme.palette.eWhite?.base,
    border: "2px solid " + theme.palette.eWhite?.base,
    color: theme.palette.ePrimary?.base,
    boxShadow: "0 4px 8px 0 rgba(0,0,0,0.2)",
  },
  fullWidth: {
    width: "100%"
  },
  dropDownContent: {
    flexFlow: "row"
  },
  mobileHeadingPart: {
    flexFlow: "column"
  }
}));

export default function UsageCalender() {
  const font=useSelector((state)=>state?.parametersWidgets?.ParameterLookup?.BASE_FONT);
  const blueColor = appStyles.outerTheme.palette.ePrimary.base;
  const greyColor = useSelector((state)=>state?.parametersWidgets?.ParameterLookup?.SECONDARY_COLOR_5);
  const [materialTheme,setMaterialTheme]=useState();
  useEffect(()=>{
    if(font && blueColor && greyColor){
      setMaterialTheme(createMuiTheme({
        typography: {
          fontFamily: font, 
          h6:{
            fontSize:"1.125rem"
          }          
        },
        overrides: {
          MuiCssBaseline: {
            "@global": {
              "@font-face": [
                // notoSansRegular,
                // notoSansLight,
                // notoSansSemiBold,
                // notoSansBold,
              ],
            },
          },
          MuiPickersStaticWrapper: {
            staticWrapperRoot: {
              minWidth: "200px",
            },
          },
          MuiPickersCalendarHeader: {
            switchHeader: {
              display: "none",
            },
            daysHeader: {
              justifyContent: "center",
              ["@media (min-width:768px)"]: {
                justifyContent: "center"
              },
            },
            dayLabel: {
              color: "greyColor",
              fontWeight: "bold",
              fontSize: "0.88rem",
              ["@media (min-width:768px)"]: {
                width: "38px"
              },
              ["@media (min-width:900px)"]: {
                width: "38px",
              },
              ["@media (min-width:1025px)"]: {
                width: "38px",
              },
            },
          },
          MuiPickersCalendar: {
            transitionContainer: {
              ["@media (min-width:320px)"]: {
                minHeight: "230px !important",
                marginTop: "5px",
              },
              ["@media (min-width:768px)"]: {
                minHeight: "250px !important",
                marginTop: "10px",
              },
              ["@media (min-width:1025px)"]: {
                minHeight: "270px !important",
                marginTop: "10px",
              },
            },
            week: {
              justifyContent: "center",
              ["@media (min-width:768px)"]: {
                justifyContent: "center"
              }
            },
          },
          MuiPickersDay: {
            daySelected: {
              backgroundColor: white,
              color: black,
              "&:hover": {
                backgroundColor: white,
              },
            },
            dayDisabled: {
              backgroundColor: blueColor,
              color: "white !important",
            },
            day: {
              ["@media (min-width:320px)"]: {
                width: "32px",
                height: "32px",
                marginRight: "7px",
                marginTop: "6px"
              },
              ["@media (min-width:768px)"]: {
                width: "38px",
                height: "38px",
                marginRight: "4px",
                marginTop: "6px"
              },
              ["@media (min-width:900px)"]: {
                width: "38px",
                height: "38px",
                marginRight: "4px",
                marginTop: "6px"
              },
              ["@media (min-width:1025px)"]: {
                width: "38px",
                height: "38px",
                marginRight: "4px",
                marginTop: "6px"
              },
              '&:hover': {
                backgroundColor: grey200
              }
            },
          },
          MuiIconButton: {
            root: {
              "&:hover": {
                backgroundColor: white,
              },
            },
          },
          MuiTooltip: {
            tooltip: {
              fontSize: "0.8rem",
              backgroundColor: white,
            },
          },
          MuiPickersBasePicker: {
           container:{
              justifyContent:"center",
              ["@media (max-width:1220px)"]: {
                flexDirection:"row"
              }
            },
            pickerView: {
              minHeight: "0px",
              paddingTop: "1rem",
              minWidth: "auto",
              width:"100%"
            },
          },
         },
      }))
    }
  }  ,[font,blueColor,greyColor])
  const useStyleClasses = useStyles();
  const [contentAvg, setContentAvg] = useState();
  const [weekend, setWeekend] = useState();
  const [weekday, setWeekday] = useState();
  const [noCommonDay, setNoCommonDay] = useState();
  const [usageTipsLink, setUsageTipsLink] = useState();
  const [current, setCurrent] = useState(moment(new Date()));
  const [currentMonth, setCurrentMonth] = useState(
    moment(new Date()).format("MMMM, YYYY")
  );
  const [contentCodeId, setContentCodeId] = useState();
  const [highUsageTipsInformation,setHighUsageTipsInformation]=useState('')
  const [totalUsage, setTotalUsage] = useState();
  const [usageUnit, setUsageUnit] = useState();
  const [dayValues, setDayValue] = useState();
  const [highestUsageDays, setHighestUsageDays] = useState();
  const [accountIdChanged, setAccountIdChanged] = useState(false);
  const equalTo = "=";
  const space = " ";
  const colon = ":";
  const {t:Labels, ready: labelReady} = useTranslation("label-HIGHEST_USAGE");
  const {t:content, ready: contentReady} = useTranslation("content-E_HIGHEST_USAGE_DAYS");
  let saId = useSelector((state) => state?.meterDetails?.getSaInfo?.saId);
  const primaryIdentifier = useSelector(
    (state) => state?.parametersWidgets?.ParameterLookup?.PRIMARY_IDENTIFIER
  );
  const languageCode = useSelector(
    (state) =>
      state?.parametersWidgets?.ParameterLookup?.TENANT_PRIMARY_LANGUAGE
  );
  let accountId = useSelector((store) => store?.meterDetails?.accountId);
  let widgets = useSelector((store) => store?.parametersWidgets?.WidgetLookUp);
  let highUsageSwitch = false;
  if (widgets) {
    widgets.forEach((item, key) => {
      if (item.widgetCode === "SIDEBAR.DASHBOARD") {
        item.children.forEach((dashChild) => {
          if (dashChild.widgetCode === "DASHBOARD.HIGHEST_USAGE") {
            if (dashChild.widgetDefaultValue === "true") {
              highUsageSwitch = true;
            } else {
              highUsageSwitch = false;
            }
          }
        });
      }
    });
  }
  useEffect(() => {
    setAccountIdChanged(true);
  }, [accountId]);
const[loading,setLoading]=useState(false)
  useEffect(() => {
    if (accountId) {
      setLoading(true)
      const startDate = moment(current)
        .startOf("month")
        .format("YYYY-MM-DD");
      const endDate = moment(current)
        .endOf("month")
        .format("YYYY-MM-DD");
      // dispatch(highestUsagedata(startDate, endDate, accountId));
      highestUsage
        .usageDays(startDate, endDate, accountId, saId, accountIdChanged)
        .then((resp) => {
          setStateData(resp);
          setLoading(false)
        })
        .catch(err => {
          setStateData(null);
          setLoading(false)
        })
    }
  }, [accountId, saId]);
  useEffect(() => {
    if (contentCodeId) {
      switch (contentCodeId?.messageContentDetails?.contentCode && contentReady) {
        case "E_HIGHEST_USAGE_DAYS_MESSAGE_COMMON_WEEKEND":
          setContentAvg(content("E_HIGHEST_USAGE_DAYS_MESSAGE_COMMON_WEEKEND").answer);
          break;
        case "E_HIGHEST_USAGE_DAYS_MESSAGE_COMMON_WEEKDAY":
          setContentAvg(
            content("E_HIGHEST_USAGE_DAYS_MESSAGE_COMMON_WEEKDAY").answer?.replace(
              "****",
              contentCodeId?.messageContentDetails?.commonWeekdayName
            )
          );
          break;
        case "E_HIGHEST_USAGE_DAYS_MESSAGE_NOCOMMON_DAY":
          setContentAvg(
            content("E_HIGHEST_USAGE_DAYS_MESSAGE_NOCOMMON_DAY").answer
              ?.replace(
                "****",
                moment(
                  contentCodeId?.messageContentDetails?.topUsageDayIntervalDate
                ).format("MMMM YYYY") 
              )
              .replace(
                "****",
                `${contentCodeId?.messageContentDetails?.topUsageDayQuantity} ${contentCodeId?.usageUnit}`
              )
          );
          break;
        default:
          setContentAvg("");
      }
    }
  }, [contentCodeId, noCommonDay, weekday, weekend, contentReady]);

  const [selectedDate, handleDateChange] = useState(
    highestUsageDays === "true"
  );
  const disableRandomDates = (date) => {
    const dateInterditesRaw = dayValues?.map((arrVal) => {
      let date = new Date(arrVal.intervalDateTime);
      return new Date(date.getFullYear(), date.getMonth(), date.getDate());
    });
    const dateInterdites = dateInterditesRaw?.map((arrVal) => {
      return arrVal.getTime();
    });
    return dateInterdites?.includes(date.getTime());
  };
  const makeJSDateObject = (Day) => {
    let dateInterditesRaws = contentCodeId?.usageQuantity?.filter(
      (event) => new Date(event.intervalDateTime)?.getDate() === Day
    );
    return dateInterditesRaws?.[0];
  };

  const filterPeriod = (startDate, endDate) => {
    setLoading(true)
    setCurrent(moment(new Date(startDate)));
    setCurrentMonth(moment(startDate).format("MMMM, YYYY"));
    // dispatch(highestUsagedata(startDate, endDate, accountId));
    highestUsage.usageDays(startDate, endDate, accountId).then((resp) => {
      setStateData(resp);
      setLoading(false)
    })
    .catch(err => {
      setStateData(null);
      setLoading(false)
    })
  };
  const setStateData = (resp) => {
    setContentCodeId(resp?.data.getUsageTrends);
    let totalUsage = resp?.data?.getUsageTrends?.totalUsage.toFixed(2);
    isNaN(totalUsage) ? setTotalUsage("0") : setTotalUsage(totalUsage);
    setUsageUnit(resp?.data.getUsageTrends.usageUnit);
    setDayValue(
      resp?.data.getUsageTrends.usageQuantity?.filter(
        (event) => event.isHighestUsageDay === "true"
      )
    );
    setHighestUsageDays(resp?.data.getUsageTrends.isHighestUsageDay);
  };
  const renderDayInPicker = (
    date,
    selectedDate,
    dayInCurrentMonth,
    dayComponent
  ) => {
    let dateInterditesRaws = makeJSDateObject(date.getDate());
    if (
      dateInterditesRaws !== undefined &&
      dateInterditesRaws?.isHighestUsageDay === "true"
    ) {
      let quantity;
      dateInterditesRaws?.noData === "true" ? quantity = Labels("E_NO_DATA") : quantity =  dateInterditesRaws?.quantity + " " + contentCodeId?.usageUnit
      return (
        <Tooltip
        enterTouchDelay={0}
          title={quantity}
          placement="top-center"
          arrow
          classes={{
            arrow: useStyleClasses.arrow,
            tooltip: useStyleClasses.tooltip,
          }}
        >
          <Badge>{dayComponent}</Badge>
        </Tooltip>
      );
    } else if (
      dateInterditesRaws !== undefined &&
      dateInterditesRaws?.isHighestUsageDay === "false"
    ) {
      let quantity;
      dateInterditesRaws?.noData === "true" ? quantity = Labels("E_NO_DATA") : quantity =  dateInterditesRaws?.quantity + " " + contentCodeId?.usageUnit
      return (
        <Tooltip
        enterTouchDelay={0}
          title={quantity}
          placement="top-center"
          arrow
          classes={{
            arrow: useStyleClasses.arrow,
            tooltip: useStyleClasses.tooltip,
          }}
        >
          <Badge>{dayComponent}</Badge>
        </Tooltip>
      );
    }
    return dayComponent;
  };
  const [monthlyavg,setMonthlyAvg] = useState()
  useEffect(()=>{
    let cal = parseFloat(totalUsage/30).toFixed(2)
    setMonthlyAvg(cal)
  },[totalUsage])
  return (
    <>
      {highUsageSwitch ? (
        <CardContent className={useStyleClasses.cardPadding}>
        {
          labelReady? 
          <Typography variant="h6" className={useStyleClasses.title}>
            <strong>{Labels("HIGHEST_USAGE_DAYS_TITLE")}</strong>
          </Typography>
          :<Skeleton/>
        }
          <Grid container className={useStyleClasses.fullWidth}>
            <Grid className={useStyleClasses.fullWidth} item>
            <Hidden smDown>
            <Grid container display="flex" direction="row" xs={12}>
             {materialTheme &&
              <Grid item xs={7} align="left">
                <MuiPickersUtilsProvider utils={DateFnsUtils}>
                  <ThemeProvider theme={materialTheme}>
                    <KeyboardDatePicker
                      displayStaticWrapperAs="desktop"
                      value={current}
                      onChange={handleDateChange}
                      disableToolbar
                      variant="static"
                      shouldDisableDate={disableRandomDates}
                      renderDay={renderDayInPicker}
                      className={useStyleClasses.calanderWidget}
                    />{" "}
                  </ThemeProvider>
                </MuiPickersUtilsProvider>
              </Grid>
              }
              <Grid item align="left" xs={5}>
              <Typography variant="caption" className={useStyleClasses.chooseViewText}>{Labels("E_HIGHEST_USAGE_CHOOSE_VIEW")}</Typography>
                <Grid
                  className={useStyleClasses.gridPadding}
                  container
                  direction="row"
                >
                  <DatesDropdown filterPeriod={filterPeriod}></DatesDropdown>
                  <Typography variant="subtitle2" className={useStyleClasses.currentMonthText}>
                    <span>{currentMonth}</span>
                  </Typography>
                </Grid>
                <Grid className={useStyleClasses.gridPadding}>
                  <Typography
                    className={useStyleClasses.messageText}
                    variant="subtitle2"
                    dangerouslySetInnerHTML={{
                      __html: contentAvg,
                    }}
                  ></Typography>
                      
                       <Typography className={useStyleClasses.tipsMsgText} variant="subtitle2">
                       {content("E_HIGHEST_USAGE_TIPS_INFORMATION")?.answer}
                       </Typography> 
                      
                    
               {loading===true ? (<Skeleton/>):(
                  <Grid className={useStyleClasses.totalUsageGrid}>
                      <Grid container direction="rows">
                        <Grid item sm={6} xs={6}>
                        {
                    labelReady ?
                  <Typography variant="subtitle2" align="left" className={useStyleClasses.totalUsageLabel}>
                      {Labels("HIGHEST_USAGE_DAYS_TOTAL")}
                      {colon}
                      {space}       
                  </Typography>
                  : <Skeleton />
                  }
                        </Grid>
                        <Grid item sm={6} xs={6}>
                        <Typography variant="h6" align="left" className={useStyleClasses.totalUsageValueText}>         
                          {totalUsage}
                          {space}
                     {usageUnit}
                        </Typography> 
                        </Grid>
                      </Grid>
                      <Grid container >
                        <Grid item sm={6} xs={6}>
                        {
                    labelReady ?
                  <Typography variant="subtitle2" align="left" className={useStyleClasses.totalUsageLabel}>
                      {Labels("E_HIGHEST_USAGE_MONTLY_AVERAGE")}
                      {colon}
                      {space}       
                  </Typography>
                  : <Skeleton />
                  }
                        </Grid>
                        <Grid item sm={6} xs={6}>
                        <Typography variant="h6" align="left" className={useStyleClasses.totalUsageValueText}>         
                        {monthlyavg}
                          {space}
                          {usageUnit}       
                        </Typography> 
                        </Grid>
                      </Grid>
                  </Grid>
                  )}
                </Grid>
              </Grid>
            </Grid>
          </Hidden>
          {/* mobile/tab */}
          <Hidden mdUp>
            
            <Grid className={`${useStyleClasses.mobileHeadingPart} ${useStyleClasses.gridPadding}`} xs={12} container>
              <Grid item>
              <Typography variant="caption" className={useStyleClasses.chooseViewText}>Choose a View</Typography>
              </Grid>
              <Grid container className={useStyleClasses.dropDownContent} item>
                <Grid item>
                  <DatesDropdown filterPeriod={filterPeriod}></DatesDropdown>
                </Grid>
                <Grid item>
                  <Typography variant="subtitle2" className={useStyleClasses.currentMonthText}>
                    <span>{currentMonth}</span>
                  </Typography>
                </Grid>
              </Grid>
            </Grid>
            <Grid className={useStyleClasses.fullWidth} direction="row">
              <Grid className={useStyleClasses.fullWidth} item sm={12}>
                <MuiPickersUtilsProvider className={useStyleClasses.fullWidth} utils={DateFnsUtils}>
                  <ThemeProvider theme={materialTheme}>
                    <KeyboardDatePicker
                      displayStaticWrapperAs="desktop"
                      value={current}
                      onChange={handleDateChange}
                      disableToolbar
                      variant="static"
                      shouldDisableDate={disableRandomDates}
                      renderDay={renderDayInPicker}
                    />{" "}
                  </ThemeProvider>
                </MuiPickersUtilsProvider>
              </Grid>
              <Grid item sm={12}>
                <Grid className={useStyleClasses.gridPadding}>
                  <Typography
                    className={useStyleClasses.quaternaryColor}
                    dangerouslySetInnerHTML={{
                      __html: contentAvg,
                    }}
                  ></Typography>
                  {contentReady ?
                       <Typography className={useStyleClasses.tipsMsgText} variant="body2">
                       {content("E_HIGHEST_USAGE_TIPS_INFORMATION")?.answer}
                       </Typography> 
                      :
                      <Skeleton/>
                      }
                    {
                      labelReady ?
                  <Typography className={useStyleClasses.totalUsageLabel} variant="subtitle2">
                    <span>
                      {Labels("HIGHEST_USAGE_DAYS_TOTAL")}
                      {colon}
                      {space}
                    </span>
                    {loading===true ? (<Skeleton/>):(
                     <span className={useStyleClasses.totalUsageValueText}>
                     {totalUsage}
                     {space}
                     {usageUnit}
                   </span>
                   )}
                  </Typography>
                  : <Skeleton />
                    }
                     {
                    labelReady ?
                  <Typography variant="subtitle2" className={useStyleClasses.totalUsageLabel}>
                    <span >
                      {"Monthly Average"}
                      {colon}
                      {space}
                    </span>       
                     <span className={useStyleClasses.totalUsageValueText}>
                     {monthlyavg}
                     {space}
                     {usageUnit}
                   </span>        
                  </Typography>
                  : <Skeleton />
                  }
                </Grid>
              </Grid>
            </Grid>
          </Hidden>
            </Grid>
          </Grid>
        </CardContent>
      ) : null}
    </>
  );
}
